var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"owl"},[_c('carousel',_vm._b({key:_vm.refreshKey,attrs:{"responsiveBaseElement":"body"},on:{"resized":_vm.resized}},'carousel',_vm.computedOptions,false),[_vm._t("items")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }